import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as filters from './filters' // global filters
import { removeToken, removeStation } from '@/utils/auth' 

import './permission'

import '@/styles/fonts/css/font-awesome.min.css'
import '@/styles/index.sass' // global css

// import Common from '../../common/index.js'
// Vue.use(Common)


Vue.config.productionTip = false
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

//hznet/power-distribution
const pathList = {
  //用电
  'pd': {
    power: '/power-distribution',
    photo: '/power-distribution',
	hydro: '/power-distribution'
  },
  //光伏
  'pv': {
    power: '/photovoltaic',
    photo: '/photovoltaic',
	hydro: '/photovoltaic'
  },
  //水电
  'hy': {
    power: '/hznet',
    photo: '/hznet',
	   hydro: '/hznet'
  },
  //全部
  'all': {
    power: '/hznet',
    photo: '/hznet',
	hydro: '/hznet'
  },
}
const pathObj = pathList[process.env.MODULE];
Vue.config.requestPath = process.env.NODE_ENV == "development" ? '/hznet' : pathObj.power;
Vue.config.requestPath_photovoltaic = process.env.NODE_ENV == "development" ? '/hznet' : pathObj.photo;
Vue.config.requestPath_hydro = process.env.NODE_ENV == "development" ? '/hznet' : pathObj.hydro;

hz.ajax.defaultErrorMessage = '网络异常，请重新刷新页面或者重新操作！<br>若问题再次出现，请联系技术人员。';
hz.ajax.ajaxSuccess = function(res){
  if(typeof res == 'string'){
    res = JSON.parse(res);
    if(res.code == 'HZ000001'){
      removeToken();
      removeStation();
      router.push("/login");
      return false
    }
  }
  return true;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js